import {
  TrackingPageTypeWithId,
  trackContentView,
} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {useTracking} from '../utils/utils';

export const useTrackLoginContentView = () => {
  const {TrackingClient, pageContextCallback} = useTracking();

  return useCallback(
    ({activeTab}: {activeTab: string}) => {
      TrackingClient.track(
        trackContentView({
          page: {
            path: pageContextCallback().path,
            search: pageContextCallback().search,
            type: TrackingPageTypeWithId.LoginModal,
            id: activeTab as unknown as number,
          },
        }),
      );
    },
    [TrackingClient, pageContextCallback],
  );
};
